import { useEffect } from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { Select } from 'antd'
import { SelectValue } from 'antd/es/select'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchBonusTransactionTypeAction } from 'store/transactions/transaction.action'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'
import { isEmpty } from 'utils/is-empty'

interface FilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const BonusTransactionTypeFilter: React.FC<FilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const dispatch = useAppDispatch()
  const walletApiClient = useApiClient(WalletsApiClient)
  const bonusTypes = useAppSelector((state) => state.transactions.bonusTypes)

  useEffect(() => {
    if (isEmpty(bonusTypes)) {
      dispatch(fetchBonusTransactionTypeAction(walletApiClient))
    }
  }, [])

  return (
    <Select
      placeholder='Bonus Type'
      value={filter.value || undefined}
      onChange={(value: SelectValue) => {
        onFilterChange({
          nextFilter: { ...filter, value },
        })
      }}
      style={{ width: '250px' }}
      allowClear
    >
      {bonusTypes.map((bonusType) => (
        <Select.Option key={bonusType.id} value={bonusType.id}>
          {bonusType.name}
        </Select.Option>
      ))}
    </Select>
  )
}
